/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DocflowFatfDialogRequest { 
    /**
     * Method where throw error
     */
    methodId: number;
    /**
     * Decision value name
     */
    name: string;
    /**
     * Decision value
     */
    value: string;
    /**
     * Clear field value for DialogResults
     */
    clear: boolean;
    /**
     * Disputable value with field name
     */
    searchFor: string;
    /**
     * Note for decision
     */
    note: string;
}

